<body  >
    <div  style="width:50%;margin: auto;margin-top: 10%;">
        <div class="card text-center cardShadow" >
            <h1 class="display-1 fw-bold" style="color:#136e38 ;">{{error}}</h1>
            <p class="fs-3 message"> <span class="text-danger">Opps!</span> {{message}}.</p>
            <!-- <p class="lead message">
                The page you’re looking for doesn’t exist.
            </p> -->
            <button class="btn alsButton" (click)="signLogin()">SignIn</button>
        </div>
    </div>
</body>
